export default __webpack_public_path__ + "static/avatar-tag-do-light-9b04882cab6479d739fbb88da1587832.png";